export default "__VITE_ASSET__3aa84e8f__"